import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useParams, useQueryParams } from '@atlassian/mpac-ui';
import invariant from 'invariant';
import React from 'react';
import TabHeader from "../../../common/components/Tabs/TabHeader";
import CloudChurnOrRenewals from "./CloudChurnOrRenewals";
import CloudConversions from "./CloudConversions";
import ErrorPage from "./Common/ErrorPage";
import ExportReport from "./ExportReport";
import FeedbackDetails from "./FeedbackDetails";
import FeedbackReports from "./FeedbackReports";
import LicenseReports from "./LicenseReports";
import ReportsFilters from "./ReportsFilters";
import { getDateRangeForAPeriodFilter } from "./ReportsFilters/ReportFilters.utils";
import SalesOrEvaluations from "./SalesOrEvaluations";
import TransactionsReports from "./TransactionsReports";
import { useAppsOfAReport } from "./useAppsOfAReport";
const reportsComponents = {
  sales: SalesOrEvaluations,
  evaluations: SalesOrEvaluations,
  conversions: CloudConversions,
  churn: CloudChurnOrRenewals,
  renewals: CloudChurnOrRenewals,
  feedback: FeedbackReports,
  licenses: LicenseReports,
  transactions: TransactionsReports,
  'feedback-details': FeedbackDetails
};

const PartnerReports = ({
  mpacBaseUrl,
  partnerId
}) => {
  const {
    reportName
  } = useParams();
  const queryParams = useQueryParams();
  invariant(reportName, 'Report name is required');
  const {
    reportingApps
  } = useAppsOfAReport(mpacBaseUrl, partnerId, reportName);
  if (!reportName || !Object.keys(reportsComponents).includes(reportName)) return /*#__PURE__*/React.createElement(ErrorPage, null);
  const SelectedComponent = reportsComponents[reportName];

  const getParamsWithActualDateRanges = () => {
    if (!queryParams.period || queryParams.period === 'custom') {
      return queryParams;
    }

    return _objectSpread(_objectSpread({}, queryParams), getDateRangeForAPeriodFilter(queryParams.period));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    headerText: "Reports",
    actions: /*#__PURE__*/React.createElement(ExportReport, {
      reportName: reportName,
      partnerId: partnerId,
      queryParams: getParamsWithActualDateRanges(),
      mpacBaseUrl: mpacBaseUrl
    })
  }), /*#__PURE__*/React.createElement(ReportsFilters, {
    reportingApps: reportingApps
  }), /*#__PURE__*/React.createElement(SelectedComponent, {
    mpacBaseUrl: mpacBaseUrl,
    partnerId: partnerId,
    queryParams: getParamsWithActualDateRanges(),
    reportName: reportName
  }));
};

export default PartnerReports;